import React from "react";
import type { ActivationFlowDefinition } from "../types";

export const firstRecordVideoFlow: ActivationFlowDefinition = {
    id: "first_record_video",
    title: "Record Video Workflow",
    steps: [
        {
            id: "record_intro",
            title: "Record yourself",
            target: "[data-tour='editor-workspace-area']",
            placement: "center",
            spotlightPadding: 14,
            content: (
                <div>
                    <div>
                        Click Record to start recording yourself. When you're done, your recording
                        will automatically load into the editor so you can edit it.
                    </div>
                    <div style={{ marginTop: 16, fontSize: 13, color: "#94A3B8" }}>
                        Want to record with remote participants?{" "}
                        <a
                            href="/studio"
                            style={{
                                color: "#A5B4FC",
                                textDecoration: "underline",
                                cursor: "pointer",
                            }}
                        >
                            Click here
                        </a>
                    </div>
                </div>
            ),
            advance: {
                type: "manual",
            },
        },
    ],
};
